import { useEffect, useState } from "react";
import { X, Gift } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

const SEEN_KEY = "aap_news_seen";

export default function NewsletterPopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(SEEN_KEY)) return;
    const t = setTimeout(() => setOpen(true), 4000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    localStorage.setItem(SEEN_KEY, "1");
    setOpen(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/subscribe", { email: email.trim(), source: "popup", send_welcome: true });
      localStorage.setItem(SEEN_KEY, "1");
      setDone(true);
      toast.success("You're in! Check your inbox for your code.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4" data-testid="newsletter-popup">
      <div className="relative w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl">
        <button onClick={dismiss} data-testid="newsletter-close" aria-label="Close"
          className="absolute right-4 top-4 z-10 text-white/80 hover:text-white">
          <X className="h-5 w-5" />
        </button>
        <div className="bg-ink px-8 py-10 text-center">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-crimson">
            <Gift className="h-7 w-7 text-white" />
          </div>
          <h2 className="font-display text-3xl font-black tracking-tight text-white">Claim your $10 off NOW!</h2>
          <p className="mt-2 text-sm text-white/70">Subscribe for future discounts and new product releases!</p>
          <p className="mt-1 text-sm font-bold text-white">Get $10 off your next purchase when you subscribe</p>
        </div>
        <div className="p-8">
          {done ? (
            <div className="text-center" data-testid="newsletter-success">
              <p className="font-display text-xl font-bold text-ink">You're subscribed! 🎉</p>
              <p className="mt-2 text-sm text-muted-foreground">Your $10-off code is on its way to your inbox.</p>
              <button onClick={() => setOpen(false)} className="mt-5 rounded-full bg-ink px-6 py-2.5 text-sm font-bold text-white hover:bg-crimson">Start shopping</button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                data-testid="newsletter-email"
                className="w-full rounded-full border border-line px-5 py-3 text-sm outline-none focus:border-crimson"
              />
              <button type="submit" disabled={busy} data-testid="newsletter-submit"
                className="w-full rounded-full bg-crimson px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-ink disabled:opacity-50">
                {busy ? "Signing you up…" : "Subscribe now!"}
              </button>
              <button type="button" onClick={dismiss} className="w-full text-center text-xs font-medium text-muted-foreground hover:text-ink">
                No thanks
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
